import {
  CryptoCurrenciesForEnovipayPayout,
  CryptoCurrenciesForManualTransfer,
} from '@bdswiss/common-enums'

const CRYPTO_NETWORK_OPTIONS = Object.values(CryptoCurrenciesForManualTransfer)

const CRYPTO_PAYOUT_NETWORK_OPTIONS = Object.values(CryptoCurrenciesForEnovipayPayout)

export {CRYPTO_NETWORK_OPTIONS, CRYPTO_PAYOUT_NETWORK_OPTIONS}
